// src/pages/Dashboard.js
import React, { useState, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { GradientButton } from "components/GradientButton";
import SaveIcon from "@mui/icons-material/Save";
import useProductData from "pages/Pawn/ImportRetrospectiveData/ImportData/data/data";
import useColumns from "pages/Pawn/ImportRetrospectiveData/ImportData/columns/mainColumns";
import dayjs from "dayjs";
import SearchBar from "components/TableExplanded/SearchBar";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import api from "_api";

const ImportData = ({ className }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setProduct] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [fetchData, setFetchData] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);

  const [viewProduct, setViewProduct] = useState(null);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchProductData = async () => {
    try {
      const { data, isStatus } = await api.product.getInterest();
      // console.log("data API", data);
      if (isStatus) setFetchData(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, []);

  const filterRows = () => {
    let filteredData = data.filter((row) =>
      Object.keys(row).some((key) => {
        const value = row[key];
        return (
          typeof value === "string" && value.toLowerCase().includes(searchTerm)
        );
      })
    );

    if (selectedDateRange[0] && selectedDateRange[1]) {
      const [startDate, endDate] = selectedDateRange;
      filteredData = filteredData.filter((row) => {
        const rowDate = dayjs(row.created_date, "DD/MM/YYYY เวลา HH:mm:ss น.");
        return (
          rowDate.isAfter(dayjs(startDate).startOf("day")) &&
          rowDate.isBefore(dayjs(endDate).endOf("day"))
        );
      });
    }

    setFilteredRows(filteredData);
  };

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };
  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };
  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen
  );

  useEffect(() => {
    setFilteredRows(data);
  }, [data]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const handleSearchClick = () => {
    filterRows();
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleClear = () => {
    setSearchTerm("");
    setSelectedDateRange([null, null]);
    setFilteredRows(data);
  };

  const handleDateRangeChange = (dates) => {
    setSelectedDateRange(dates);
  };
  return (
    <div className={className}>
      <Grid container spacing={10} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รายการนำเข้า
          </Typography>

          <GradientButton
            onClick={handleModalOpen}
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "48px",
            }}
          >
            <Typography style={{ marginRight: "8px" }}>ส่งออก Excel</Typography>
            <SaveIcon fontSize="medium" />
          </GradientButton>
        </Grid>
      </Grid>
      <SearchBar
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
        handleSearchClick={handleSearchClick}
        handleClear={handleClear}
        handleDateRangeChange={handleDateRangeChange}
        fieldNames={"overdueBorrowItems"}
        QRCode={false}
      />
      <CustomTable
        columns={columns}
        data={filteredRows.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )}
        hiddenColumns={["checkbox", "expand"]}
      />
      <CustomPagination
        count={filteredRows.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default ImportData;
